<template>
    <div></div>
</template>
<script>
import axios from 'axios';
import * as THREE from 'three';

export default {

    data() {
        return {
            stream: null,
            audioLoader: null,
            listener: null,
            audio: null,
            dataArray: null,
            audioData: [],
            initz: false,
            firstClick: false,
            currentStream: ''
        }
    },
    components: {},
    computed: {
        currentArtwork() {
            return this.$store.state.currentArtwork;
        },
        currentArtworkTimestamp() {
            return this.$store.state.currentArtworkTimestamp;
        },
    },
    mounted() {
        window.addEventListener('touchstart', this.init);
        document.addEventListener('click', this.init);
        // setTimeout(function() {
        //     let self = this;
        //     document.querySelectorAll(".artwork-title").forEach(function(item) {

        //         console.log("ciao");
        //     })
        // }, 1000)
    },
    methods: {
        init() {
            // console.log("qui");
            if (!this.firstClick) {
                // let fftSize = 2048;
                // this.audioLoader = new THREE.AudioLoader();
                // this.listener = new THREE.AudioListener();
                // this.audio = new THREE.Audio(this.listener);
                // this.audio.crossOrigin = "";
                // this.firstClick = true;
            }

        },
        play() {





            
            // let self = this;
            // this.audioLoader.load(this.stream, function(buffer) {

            //     console.log(self.stream + " ---- " + self.currentStream);

            //     if (self.stream != self.currentStream) {
            //         console.log("dentro play 1");
            //         self.audio.setBuffer(buffer);
            //         self.audio.setLoop(false);
            //         self.audio.setVolume(0.5);
            //         self.audio.pause();
            //         self.audio.play();
            //         self.currentStream = self.stream;
            //     } else {
            //         console.log("dentro play 2");
            //         self.audio.stop(0);

            //         let all_canvas = document.querySelectorAll(".main_canvas");
            //         all_canvas.forEach(function(item) {
            //             // item.classList.remove("grow");
            //             item.classList.add("remove");
            //         })
                    

            //         let artworks = document.querySelectorAll(".artwork-title");
            //         artworks.forEach(function(item) {
            //             // item.classList.remove("grow");
            //             item.classList.remove("active");
            //         })

                    

            //     }
            //     self.currentStream = self.stream;
            // });
            // this.analyser = new THREE.AudioAnalyser(this.audio, this.fftSize);
            // this.analyser.analyser.maxDecibels = -3;
            // this.analyser.analyser.minDecibels = -100;
            // this.dataArray = this.analyser.data;
            // this.getAudioData(this.dataArray);
        },
        getAudioData(data) {
            //Split array into 3
            if (data) {
                let frequencyArray = this.splitFrenquencyArray(data, 3);

                // Make average of frenquency array entries
                for (var i = 0; i < frequencyArray.length; i++) {
                    let average = 0;

                    for (var j = 0; j < frequencyArray[i].length; j++) {
                        average += frequencyArray[i][j];
                    }
                    this.audioData[i] = average / frequencyArray[i].length;
                }
            }
            return this.audioData;
        },
        splitFrenquencyArray(arr, n) {
            var tab = Object.keys(arr).map(function(key) {
                return arr[key];
            });
            var len = tab.length,
                result = [],
                i = 0;

            while (i < len) {
                var size = Math.ceil((len - i) / n--);
                result.push(tab.slice(i, i + size));
                i += size;
            }

            return result;
        },
        animate() {
            // get audio data
            this.getAudioData(this.dataArray);

            // // animate particles
            // particles.forEach((particle, i) => (particle.position.y = audioData[0] / 200 - 0.48));

            // // animate planets
            // if (audioData[0] >= 1) {
            //     planetBig.rotation.z += 0.005;
            //     planetSmall.scale.y = planetSmall.scale.x = planetSmall.scale.z = 5 + audioData[0] / 20;
            //     planetMedium.scale.y = planetMedium.scale.x = planetMedium.scale.z = 5 + audioData[0] / 20;
            // }

            // // create stars
            // if (audioData[0] >= 100 && selectableStars.length < 100) {
            //     createStar();
            // }
            // this.$store.commit('setSoundFrequency', this.audioData[0])
            requestAnimationFrame(this.animate);
            this.render();
        },
        render() {
            if (this.analyser) {
                this.analyser.getFrequencyData();
            }
        }
    },
    watch: {
        currentArtworkTimestamp(n, o) {
            if (n == o) {
                console.log("uguale");
            }
            if (n && n != o) {
                let self = this;
                if (!this.initz) {
                    this.animate();
                    this.initz = true;
                }

                if (this.audio && this.audio != null && this.stream) {
                    this.audio.stop(0);
                    this.audio.pause();
                }
                this.stream = this.currentArtwork.acf.sound.url;
                setTimeout(function() {
                    self.play();
                }, 500)
            }
        }
    }
}
</script>